import { useState } from 'react';
import { Copy, Share2, X } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const platforms = [
  { key: 'whatsapp', label: 'WhatsApp', url: (u, t) => `https://wa.me/?text=${encodeURIComponent(t + ' ' + u)}` },
  { key: 'x', label: 'X / Twitter', url: (u, t) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(t)}&url=${encodeURIComponent(u)}` },
  { key: 'facebook', label: 'Facebook', url: (u) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}` },
  { key: 'pinterest', label: 'Pinterest', url: (u, t) => `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(u)}&description=${encodeURIComponent(t)}` },
];

export function ShareModal({ open, onOpenChange, product }) {
  const shareUrl = `${window.location.origin}/product/${product?.id}`;
  const title = product ? `Discover the ${product.name} at Maison D'Aurelia` : '';

  const copy = () => {
    navigator.clipboard.writeText(shareUrl);
    toast.success('Link copied to clipboard');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="share-modal" className="bg-surface-elevated border-border max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl flex items-center gap-2"><Share2 size={18} className="text-gold" /> Share this piece</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 mt-2">
          {platforms.map((p) => (
            <a key={p.key} data-testid={`share-${p.key}`} href={p.url(shareUrl, title)} target="_blank" rel="noreferrer"
              className="border border-border rounded px-4 py-3 text-sm text-center hover:border-gold hover:text-gold transition-colors">
              {p.label}
            </a>
          ))}
        </div>
        <button data-testid="share-copy-link" onClick={copy} className="mt-2 flex items-center justify-center gap-2 border border-gold/40 text-gold rounded px-4 py-3 text-sm hover:bg-gold/10 transition-colors">
          <Copy size={15} /> Copy Link
        </button>
      </DialogContent>
    </Dialog>
  );
}
